
import { Component, Vue } from 'vue-property-decorator';
import { getCertificateLink } from '@/api/business';

@Component({})
export default class extends Vue {
  private handleRegisterCertificate() {
    // this.$message.warning('준비중인 기능입니다 빠른 시일내에 준비하겠습니다.');
    getCertificateLink().then((res) => {
      if (res.data) window.open(res.data);
      else window.open('https://www.popbill.com/Taxinvoice/Setting/Cert');
    }).catch(() => {
      window.open('https://www.popbill.com/Taxinvoice/Setting/Cert');
    });
  }
}
